/**
 * return object of headers
 */

export default () => {
    let options = {};

    if (localStorage.userLogin) {
        let userLogin = JSON.parse(localStorage.userLogin)
            options   = {
            'headers': {
                'token': userLogin.token,
            },
        }
    }

    return options;
}